/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-15T16:02:24.137
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportRentHouseBig,
	listReportRentHouseBigInit,
	listReportRentHouseBigByAuthorizations,
	deleteReportRentHouseBig
	
} from '@api/report/ReportRentHouseBig';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportRentHouseBig({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentHouseBig(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentHouseBigByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentHouseBigByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentHouseBigInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentHouseBigInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportRentHouseBig({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentHouseBig({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
